var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("calendarTour", {
        ref: "calendarTour",
        attrs: { id: "calendarTour" },
        on: { tourStoped: _vm.stopTour },
      }),
      _c("div", { attrs: { id: "calendarTourContainer" } }),
      _c("div", [
        _c("div", { staticClass: "pickup-actions-container" }, [
          _c(
            "span",
            [
              _c(
                "b-tooltip",
                {
                  attrs: {
                    label: _vm.$t("pages.pickup_management.clear_filters"),
                    position: "is-top",
                  },
                },
                [
                  _c("b-button", {
                    attrs: {
                      "icon-left": "filter",
                      type: "is-danger",
                      rounded: "",
                    },
                    on: { click: _vm.clearFilters },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            [
              _c(
                "b-tooltip",
                {
                  attrs: {
                    id: "calendarTourBtn",
                    label: _vm.$t("pages.pickup_management.page_tutorial"),
                    position: "is-top",
                  },
                },
                [
                  _c("b-button", {
                    attrs: {
                      "icon-left": "question",
                      type: "is-info",
                      rounded: "",
                    },
                    on: { click: _vm.startTour },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "custom-container" }, [
          _c(
            "div",
            { staticClass: "column is-one-fifth" },
            [
              _c(
                "b-field",
                {
                  attrs: {
                    label: _vm.$t(
                      "pages.pickup_management.calendar.range_dates_label"
                    ),
                  },
                },
                [
                  _c("b-datepicker", {
                    attrs: { placeholder: "Click to select..." },
                    model: {
                      value: _vm.startDate,
                      callback: function ($$v) {
                        _vm.startDate = $$v
                      },
                      expression: "startDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "left-box panel-block column is-one-fifth" },
            [
              _c(
                "b-field",
                {
                  attrs: { label: "Find a collect" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.filterByRo.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("b-input", {
                    attrs: { placeholder: "RO" },
                    model: {
                      value: _vm.filterByRoValue,
                      callback: function ($$v) {
                        _vm.filterByRoValue = $$v
                      },
                      expression: "filterByRoValue",
                    },
                  }),
                  _c(
                    "p",
                    { staticClass: "control" },
                    [
                      _c("b-button", {
                        staticClass: "button is-warning",
                        attrs: {
                          disabled: _vm.loading,
                          "icon-right": "arrow-right",
                        },
                        on: { click: _vm.filterByRo },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.selectedGroup.collectGroup
            ? _c(
                "span",
                { staticClass: "buttons" },
                [
                  _c(
                    "b-button",
                    {
                      class: !_vm.showNotRecentlyCollected
                        ? "is-purple"
                        : "is-danger",
                      attrs: { disabled: _vm.loading, "icon-left": "history" },
                      on: { click: _vm.switchShowNotRecentlyCollected },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "pages.pickup_management.calendar.not_recently_collected_btn"
                            )
                          ) +
                          " "
                      ),
                      _c("span", { staticClass: "count" }, [
                        _vm._v(
                          " " + _vm._s(_vm.notRecentlyCollected.length) + " "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "button is-link",
                      attrs: { disabled: _vm.loading, "icon-left": "envelope" },
                      on: { click: _vm.switchOpenConfirmationTemplates },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "pages.pickup_management.collect_confirmation.confirmation_templates"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "button is-info",
                      attrs: {
                        disabled: _vm.loading,
                        "icon-left": "door-closed",
                      },
                      on: { click: _vm.openClosuresGrid },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "pages.pickup_management.calendar.show_closures_grid"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "button is-warning",
                      attrs: {
                        disabled: _vm.loading,
                        loading: _vm.loading,
                        "icon-left": "sync",
                      },
                      on: { click: () => _vm.refresh() },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.refresh")) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "caption d-flex-space-between" }, [
          _c("div", [
            _c("span", { staticClass: "subtitle caption-title" }, [
              _vm._v(
                _vm._s(_vm.$t("pages.pickup_management.calendar.caption")) +
                  " :"
              ),
            ]),
            _c("br"),
            _c("span", [
              _c("i", { staticClass: "fas fa-door-closed has-text-danger" }),
              _vm._v(
                " : " +
                  _vm._s(
                    _vm.$t(
                      "pages.pickup_management.calendar.contains_closing_date"
                    )
                  )
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "relative", attrs: { id: "status" } },
            [
              _c(
                "span",
                {
                  staticClass: "subtitle caption-title",
                  attrs: { id: "calendar-step-status-color" },
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.status")) + ":")]
              ),
              _c("br"),
              _c(
                "div",
                { staticClass: "d-flex-space-around d-flex-justify-center" },
                [
                  _c(
                    "span",
                    { staticClass: "SC status", attrs: { id: "SC-caption" } },
                    [
                      _vm._v(
                        "C: " +
                          _vm._s(
                            _vm.$t("pages.pickup_management.calendar.status_c")
                          )
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    { staticClass: "SP status", attrs: { id: "SP-caption" } },
                    [
                      _vm._v(
                        "P: " +
                          _vm._s(
                            _vm.$t("pages.pickup_management.calendar.status_p")
                          )
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "d-flex-space-around d-flex-justify-center" },
                [
                  _c(
                    "span",
                    { staticClass: "ST1 status", attrs: { id: "ST1-caption" } },
                    [
                      _vm._v(
                        "T1: " +
                          _vm._s(
                            _vm.$t("pages.pickup_management.calendar.status_t1")
                          )
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "ST1b status",
                      attrs: { id: "ST1b-caption" },
                    },
                    [
                      _vm._v(
                        "T1b: " +
                          _vm._s(
                            _vm.$t(
                              "pages.pickup_management.calendar.status_t1b"
                            )
                          )
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    { staticClass: "ST2 status", attrs: { id: "ST2-caption" } },
                    [
                      _vm._v(
                        "T2: " +
                          _vm._s(
                            _vm.$t("pages.pickup_management.calendar.status_t2")
                          )
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    { staticClass: "ST3 status", attrs: { id: "ST3-caption" } },
                    [
                      _vm._v(
                        "T3: " +
                          _vm._s(
                            _vm.$t("pages.pickup_management.calendar.status_t3")
                          )
                      ),
                    ]
                  ),
                ]
              ),
              _c("div", { staticClass: "flex f-center" }, [
                _c(
                  "span",
                  {
                    staticClass: "SMultiple",
                    attrs: { id: "SMultiple-caption" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("pages.pickup_management.calendar.mixed_status")
                      )
                    ),
                  ]
                ),
              ]),
              _c(
                "b-button",
                {
                  staticClass: "is-small is-primary is-outlined is-rounded",
                  attrs: { id: "pin-button" },
                  on: { click: _vm.pinCaption },
                },
                [_c("b-icon", { attrs: { icon: "thumbtack" } })],
                1
              ),
            ],
            1
          ),
        ]),
        !_vm.showNotRecentlyCollected
          ? _c(
              "div",
              [
                _c("ag-grid-vue", {
                  staticClass: "ag-theme-balham",
                  staticStyle: { width: "100%", height: "1000px" },
                  attrs: {
                    id: "calendar-step-grid",
                    "row-data": _vm.gridData,
                    "grid-options": _vm.gridOptions,
                    pagination: true,
                    "pagination-auto-page-size": true,
                    "multi-sort-key": "ctrl",
                    modules: _vm.modules,
                    "row-selection": "multiple",
                    "group-hide-open-parents": true,
                  },
                  on: { "grid-ready": _vm.onGridReady },
                }),
              ],
              1
            )
          : _c(
              "div",
              [
                _c("ag-grid-vue", {
                  staticClass: "ag-theme-balham",
                  staticStyle: { width: "100%", height: "1000px" },
                  attrs: {
                    id: "calendar-step-grid",
                    "row-data": _vm.notRecentlyCollected,
                    "grid-options": _vm.gridOptions,
                    pagination: true,
                    "pagination-auto-page-size": true,
                    "multi-sort-key": "ctrl",
                    modules: _vm.modules,
                    "row-selection": "multiple",
                    "group-hide-open-parents": true,
                  },
                  on: { "grid-ready": _vm.onGridReady },
                }),
              ],
              1
            ),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.showCollectCreation,
            scroll: "keep",
            "has-modal-card": "",
            "full-screen": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.showCollectCreation = $event
            },
          },
        },
        [
          _c("collectCreation", {
            attrs: {
              endusers: _vm.selectedEndusers,
              "selected-group": _vm.selectedGroup.collectGroup,
            },
            on: {
              close: _vm.closeCollectCreation,
              nextTourStep: _vm.nextTourStep,
            },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.showCollectInfo,
            scroll: "keep",
            "has-modal-card": "",
            "full-screen": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.showCollectInfo = $event
            },
          },
        },
        [
          _c("collectInfo", {
            attrs: {
              "selected-group": _vm.selectedGroup,
              collects: _vm.selectedCollects,
              "associated-collects": _vm.associatedCollects,
            },
            on: {
              nextTourStep: _vm.nextTourStep,
              close: _vm.closeCollectInfos,
            },
          }),
        ],
        1
      ),
      _vm.selectedEnduser
        ? _c(
            "b-modal",
            {
              attrs: {
                active: _vm.settingEnduserComment,
                scroll: "keep",
                "has-modal-card": "",
              },
              on: {
                "update:active": function ($event) {
                  _vm.settingEnduserComment = $event
                },
              },
            },
            [
              [
                _c("div", { staticClass: "modal-card" }, [
                  _c("header", { staticClass: "modal-card-head" }, [
                    _c("p", { staticClass: "modal-card-title" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "pages.pickup_management.pickup_management.set_enduser_comments"
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c(
                    "section",
                    {
                      staticClass: "modal-card-body",
                      attrs: { id: "pickup-step-14" },
                    },
                    [
                      _c("b-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.selectedEnduser.comment,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedEnduser, "comment", $$v)
                          },
                          expression: "selectedEnduser.comment",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("footer", { staticClass: "modal-card-foot" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-fullwidth",
                        on: {
                          click: () => {
                            _vm.settingEnduserComment = false
                            _vm.selectedEnduser.comment = _vm.tmp
                            _vm.selectedEnduser = null
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "button is-info is-fullwidth",
                        attrs: { id: "pickup-step-15" },
                        on: { click: _vm.setEnduserComment },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                    ),
                  ]),
                ]),
              ],
            ],
            2
          )
        : _vm._e(),
      _vm.selectedEnduser
        ? _c(
            "b-modal",
            {
              attrs: {
                active: _vm.showClosure,
                scroll: "keep",
                "has-modal-card": "",
                "full-screen": "",
              },
              on: {
                "update:active": function ($event) {
                  _vm.showClosure = $event
                },
              },
            },
            [
              _c("closure", {
                attrs: { enduser: _vm.selectedEnduser },
                on: { close: _vm.closeClosure, nextTourStep: _vm.nextTourStep },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.showClosuresGrid,
            scroll: "keep",
            "has-modal-card": "",
            "full-screen": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.showClosuresGrid = $event
            },
          },
        },
        [
          _c("closuresGrid", {
            attrs: { "endusers-data": _vm.gridData },
            on: { close: _vm.closeClosuresGrid },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.showConfirmationTemplate,
            scroll: "keep",
            "has-modal-card": "",
            "full-screen": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.showConfirmationTemplate = $event
            },
          },
        },
        [
          _c("confirmationTemplate", {
            attrs: { "selected-group": _vm.selectedGroup },
            on: { close: _vm.switchOpenConfirmationTemplates },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }